export default __webpack_public_path__ + "static/media/loading-animation.941df5e0.gif";